import { useCallback } from "react";
import { useInputValue } from "./useInputValue.js";
import { useNativeInput } from "./useNativeInput.js";
const useCheckboxInput = (props, forwardedRef) => {
  const { state, onChange } = useInputValue({
    ...props,
    emptyValue: false,
    extractValue: useCallback((element) => element.indeterminate ? null : element.checked, [])
  });
  const inputProps = useNativeInput(props, forwardedRef);
  return {
    ...inputProps,
    onChange,
    value: "on",
    indeterminate: state === null,
    checked: state === true
  };
};
export {
  useCheckboxInput
};
//# sourceMappingURL=useCheckboxInput.js.map
